import React, { useEffect, useState } from "react";
import { api, apiJson } from "@/api/client.js";
import { DataTable } from "@/components/DataTable.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

const CATS = ["chasse", "camp", "cuisine", "vetements", "securite", "vehicule", "electronique", "autre"];

export function GearPage() {
  const { ui } = useOrignalUi();
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("camp");
  async function reload() {
    setItems((await api("/api/equipment")).items);
  }
  useEffect(() => { reload().catch(() => {}); }, []);
  async function submit(e) {
    e.preventDefault();
    if (!name.trim()) return;
    await apiJson("/api/equipment", { name, category, trip_id: "trip_terrain_3j" });
    setName("");
    await reload();
  }
  return (
    <main className="og-page" data-testid="page-gear">
      <h1>{ui.gear.title}</h1>
      <p className="og-lead">{ui.gear.subtitle}</p>
      <form className="og-inline" onSubmit={submit}>
        <input className="og-input" value={name} onChange={(e) => setName(e.target.value)} data-testid="gear-name" />
        <select className="og-input" value={category} onChange={(e) => setCategory(e.target.value)}>
          {CATS.map((c) => <option key={c} value={c}>{ui.categories[c] || c}</option>)}
        </select>
        <button className="og-btn og-btn--primary" type="submit">{ui.app.add}</button>
      </form>
      <DataTable
        rows={items.map((g) => ({ ...g, statusLabel: ui.status[g.status] || g.status }))}
        searchKeys={["name", "comment"]}
        columns={[{ key: "name", label: ui.gear.title }, { key: "category", label: ui.territory.category }, { key: "statusLabel", label: ui.status.to_bring }]}
        emptyLabel={ui.gear.empty}
        testId="gear-table"
      />
    </main>
  );
}
